import { Column } from '@tanstack/react-table';
import { ReactNode, createContext, useContext } from 'react';

export interface Option {
  id: string;
  displayName: string;
  count: number;
}

interface ExternalFilterOptions {
  options?: Record<string, Option[]>;
}

const ExternalFilterOptionsContext = createContext<ExternalFilterOptions>({});

export const ExternalFilterOptionsProvider = ({
  options,
  children,
}: {
  options?: Record<string, Option[]>;
  children: ReactNode;
}) => (
  <ExternalFilterOptionsContext.Provider
    value={{ options }}
    children={children}
  />
);

export const useExternalOptions = (
  column: Column<any> | undefined
): Option[] | undefined => {
  const { options } = useContext(ExternalFilterOptionsContext);
  return options && column?.id && options[column.id]
    ? options[column.id]
    : undefined;
};
